module.exports = "\r\n.row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}\r\n\r\n.thead {\r\n    background: #808080;\r\n    color: #fff;\r\n}\r\n\r\ntable{\r\n    border: 1px solid #444;\r\n    margin-top: 30px;\r\n}\r\n\r\ntable select, table input{\r\n    width: 200px;\r\n}\r\n\r\n.table-responsive table td{\r\n    padding:0.5em;\r\n    font-size:1em;\r\n    width:250px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/Agreements/agreements-form/agreements-form.component.css
// module id = ./src/app/recovery/Agreements/agreements-form/agreements-form.component.css
// module chunks = main